import React from 'react';
import { routerShape } from 'react-router/lib/PropTypes';
import { withRouter } from 'react-router';

const Front = ({ router }) => {
  let firstTapOn = new Date();
  let tapCount = 1;
  const onClick = () => {
    if (tapCount === 2) {
      tapCount = 1;
      router.push('/');
      return;
    }

    if (new Date() - firstTapOn < 5000) {
      return tapCount += 1;
    }

    firstTapOn = new Date();
    tapCount = 1;
  };

  return (
    <div className="o-center-page u-color-white" onClick={onClick}>
      <div className="c-squire-logo">
        SQUĪRE
      </div>
    </div>
  );
};

Front.propTypes = {
  router: routerShape.isRequired,
};

export default withRouter(Front);
